import type { AllergyIntolerance, Reference } from '@medplum/fhirtypes'
import { ExtendedAllergy } from '@seen/core/models/allergies'
import { IconVirus } from '@tabler/icons-react'
import type { JSX } from 'react'
import { useRead } from '#src/hooks/useRead.ts'

export function AllergyOption({
  allergy,
}: {
  allergy: Reference<AllergyIntolerance>
}): JSX.Element {
  const { data: instance } = useRead(ExtendedAllergy, allergy)
  return (
    <div className="flex items-center gap-2">
      <div className="p-0.5">
        <IconVirus className="size-4 shrink-0" />
      </div>
      <span>{instance?.name}</span>
    </div>
  )
}
